import { TariffStatusType } from '../../shared/models/types'
import { WallboxDto } from '../api/dto/wallbox.dto'
import { TariffModel } from '../models/wallbox-model'
import { getTariff } from './get-tariff'

/**
 * Function for mapping proper tariff to be displayed inside wallbox card.
 * - First, FE checks if there is active tariff and display it as first choice.
 * - If there is no active tariff, then FE checks for inactive tariffs and takes first tariff element from array as valid one.
 * - IF there is no active and inactive tariffs, then FE checks for expired tariffs and takes first element from array as valid one.
 * @param tariff - single WallboxDto object
 * @returns TariffModel or undefined
 */
export const getTariffToDisplay = (tariff: WallboxDto): TariffModel | undefined => {
  if (tariff.activeTariff) {
    return getTariff(tariff.activeTariff, TariffStatusType.active)
  }

  if (tariff.inactiveTariffs.length > 0) {
    return getTariff(tariff.inactiveTariffs[0], TariffStatusType.inactive)
  }

  if (tariff.expiredTariffs.length > 0) {
    return getTariff(tariff.expiredTariffs[0], TariffStatusType.expired)
  }
}
